import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ModalLayoutModule } from '../../../../global/modal-layout';

export interface UnitDeletionConfirmationData {
    entityName: string;
    affectedForcesCount: number;
    affectedUsersCount: number;
    defaultAlertMessage: string;
}

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, IonicModule, ModalLayoutModule],
    selector: 'abs-unit-deletion-confirmation',
    template: `
        <abs-modal-layout title="Delete Unit: {{ data.entityName }}" [showClose]="false">
            <div class="warning">
                <div>
                    <p>
                        This unit is used in <strong>{{ data.affectedForcesCount }}</strong> force{{
                            data.affectedForcesCount !== 1 ? 's' : ''
                        }}
                        owned by <strong>{{ data.affectedUsersCount }}</strong> user{{ data.affectedUsersCount !== 1 ? 's' : '' }}.
                    </p>
                    <p>If deleted, these users will receive an alert.</p>
                </div>
            </div>

            <div class="form">
                <div class="form-row">
                    <label>Alert message (editable):</label>
                    <textarea [(ngModel)]="customAlertMessage" rows="4"></textarea>
                </div>
            </div>

            <div class="buttons">
                <ion-button color="medium" (click)="cancel()">Cancel</ion-button>
                <ion-button color="danger" (click)="confirm()">Delete &amp; Alert</ion-button>
            </div>
        </abs-modal-layout>
    `,
    styles: []
})
export class UnitDeletionConfirmationComponent implements OnInit {
    @Input() data: UnitDeletionConfirmationData;
    @Output() onConfirm = new EventEmitter<string>();
    @Output() onCancel = new EventEmitter<void>();

    customAlertMessage = '';

    constructor(private modalController: ModalController) {}

    ngOnInit() {
        this.customAlertMessage = this.data?.defaultAlertMessage || '';
    }

    confirm() {
        this.modalController.dismiss({ customAlertMessage: this.customAlertMessage }, 'confirm');
    }

    cancel() {
        this.modalController.dismiss(null, 'cancel');
    }
}
